import { Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';
import { ActivatedRoute, Router } from '@angular/router'; // Importa el Router
import { LoadingService } from '../../services/general/loading.service';
import { LogTackingService } from '../../services/logs/log-tacking.service';
import { LogsTrackingRequest, LogsTrackingResponse } from '../../interfaces/logs_tracking.interface.';
import { ErrorAlertComponent } from "../../components/shared/error-alert/error-alert.component";
import { ConfirmationModalComponent } from "../../components/shared/confirmation-modal/confirmation-modal.component";
import { HttpClient } from '@angular/common/http';
import { Global } from '../../services/global';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ErrorAlertComponent, ConfirmationModalComponent],

  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading = false;
  errorMessage = '';
  showAlertError: boolean = false
  showNoRoleModal: boolean = false
  noRoleModalMessage: string = ''
  ip = ''
  log_info: LogsTrackingRequest = {
    email: '',
    action: 'Login',
    details: '',
    ip_address: ''
  }

  // Configuración de Google OAuth
  private readonly API_URL = Global.url + '/auth'; 
  private readonly clientId = environment.oauth.clientId;
  private readonly redirectUri = `${this.API_URL}/CognitoCallbackBoris`;
  private readonly cognitoDomain = environment.oauth.cognitoDomain;
  private readonly identityProvider = environment.oauth.identityProvider;
  private readonly scopes = environment.oauth.scopes;

  constructor(
    private readonly fb: FormBuilder,
    private readonly loginService: LoginService,
    private readonly router: Router,
    private readonly _loadingService: LoadingService,
    private readonly _logsService: LogTackingService,
    private readonly http: HttpClient,
    private readonly route: ActivatedRoute
  ) {
    this.loginForm = this.fb.group({

      email: ['', Validators.required],
      password: ['', Validators.required]
    });

  }

  ngOnInit(): void {
    this.getIp();
    try {
      const code = this.route.snapshot.queryParamMap.get('code');
      if (code) {
        this.exchangeCodeForToken(code);
      }
    } catch (error) {
      console.error('Error al leer los parámetros de la URL:', error);
      alert('Hubo un problema al procesar la autenticación. Intenta de nuevo.');
    }
  }

  onSubmit(form: any) {
    this._loadingService.setLoading(true)
    this.log_info.email = this.loginForm.value.email
    this.log_info.ip_address = this.ip
    if (this.loginForm.valid) {
      this.isLoading = true; // Mostrar indicador de carga
      this.errorMessage = ''; // Limpiar mensaje de error
      const credentials = this.loginForm.value;
      this.loginService.login(credentials)
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            this.loginService.setCookie(response.token).subscribe({
              next: (response) => {
                this.log_info.details = `Success: Ingreso al aplicativo con exito ` 
                this.createTrackingLog()
                this.router.navigate(['/pages/']); // Redirigir a la ruta protegida
                this._loadingService.setLoading(false)
              },
              error: (error) => {
                this.isLoading = false;
                this.errorMessage = error.error.message
                this.log_info.details = `Error: ${this.errorMessage} `
                this.showErrorComponent(form)
                
              }
            })
          },
          error: (error) => {
            this.isLoading = false;    
            this.errorMessage = error.error.message
            this.log_info.details = `Error: ${this.errorMessage} `
            this.showErrorComponent(form)
  
          }
        });
    }
  }

  showErrorComponent(form: NgForm) {
    this._loadingService.setLoading(false);
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      form.resetForm()
    }, 5000);
  }
  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }

  getIp(){
    this.loginService.getIPAddress().subscribe((data: any) => {
      this.ip = data.IPv4
      localStorage.setItem('ip', this.ip)
    });
  }

  loginWithGoogle(): void {
    const oauthUrl = `${this.cognitoDomain}/oauth2/authorize?response_type=code&client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&identity_provider=${this.identityProvider}&scope=${this.scopes.join('+')}`;
    window.location.href = oauthUrl;
    this._loadingService.setLoading(true)
  }

  private exchangeCodeForToken(code: string): void {
    this._loadingService.setLoading(true)
    this.http.post(`${this.API_URL}/tokenv2`, { code }).subscribe({
      next: (resp: any) => {
        if (!resp) {
          console.warn('La respuesta del backend no contiene un email válido:', resp);
          alert('No se pudo recuperar la información del usuario o no tiene un correo y email valido.');
          return;
        }

        // Verificar si el usuario tiene un rol asignado
        if (!resp.rol || resp.rol === null || resp.rol === undefined || resp.rol === '') {
          this._loadingService.setLoading(false);
          
          // Registrar solicitud de acceso
          this.loginService.saveRoleRequest(resp.email).subscribe({
            next: (response: any) => {
              console.log('Solicitud de rol registrada exitosamente:', response);
              
              // Construir mensaje personalizado con la respuesta del backend
              if (response && response.message) {
                this.noRoleModalMessage = this.formatSuccessMessage(response, resp.email);
              } else {
                this.noRoleModalMessage = 'No tienes un rol asignado en el sistema.\n\nPor favor, solicita autorización a la Mesa de Servicios para acceder al aplicativo.';
              }
              
              this.showNoRoleModal = true;
            },
            error: (error) => {
              console.error('Error al registrar la solicitud de rol:', error);
              
              // Manejar el caso de solicitud ya existente (409)
              if (error.status === 409 && error.error) {
                this.noRoleModalMessage = this.formatPendingMessage(error.error, resp.email);
              } else {
                this.noRoleModalMessage = 'No tienes un rol asignado en el sistema.\n\nPor favor, solicita autorización a la Mesa de Servicios para acceder al aplicativo.';
              }
              
              this.showNoRoleModal = true;
            }
          });
          
          // Registrar en los logs
          this.log_info.email = resp.email || 'Desconocido';
          this.log_info.ip_address = this.ip;
          this.log_info.details = 'Error: Usuario sin rol asignado (custom:rol)';
          this.createTrackingLog();
          return;
        }

        sessionStorage.setItem('email', resp.email);
        localStorage.setItem('authToken', resp.access_token);
        localStorage.setItem('userName', resp.email);
        localStorage.setItem('user_role', resp.rol);
        this.loginService.setCookie(resp.access_token).subscribe({
              next: (response) => {
                this.router.navigate(['/pages']); 
                this._loadingService.setLoading(false)
              },
              error: (error) => {
                console.error('No se creo la cookie de sesion:', error);
              }  
        })
      },
      error: (err) => {
        console.error('Fallo al intercambiar el código:', err);
        alert('Ocurrió un error al conectarse con el servidor y se verifico tu correo electronico. Cierra la pestaña y intenta nuevamente.');
      }
    });
  }

  onNoRoleModalClose() {
    this.showNoRoleModal = false;
    // Redirigir al login
    this.router.navigate(['/login']);
  }

  private formatSuccessMessage(response: any, email: string): string {
    const message = response.message || 'Solicitud de acceso enviada exitosamente';
    const info = response.info || 'Un administrador revisará tu solicitud y asignará el rol correspondiente';
    const userEmail = response.email || email;
    
    return `${message}\n\n${info}\n\nCorreo: ${userEmail}`;
  }

  private formatPendingMessage(errorData: any, email: string): string {
    const message = errorData.message || 'Ya existe una solicitud pendiente para este email';
    const info = errorData.info || 'Tu solicitud está siendo revisada por un administrador';
    const userEmail = errorData.email || email;
    
    let formattedMessage = `${message}\n\n${info}\n\nCorreo: ${userEmail}`;
    
    // Formatear la fecha si existe
    if (errorData.created_at) {
      const formattedDate = this.formatDate(errorData.created_at);
      formattedMessage += `\n\nSolicitud creada: ${formattedDate}`;
    }
    
    return formattedMessage;
  }

  private formatDate(dateString: string): string {
    try {
      const date = new Date(dateString);
      
      // Verificar si la fecha es válida
      if (isNaN(date.getTime())) {
        return dateString;
      }
      
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      
      return `${day}/${month}/${year} a las ${hours}:${minutes}`;
    } catch (error) {
      console.error('Error al formatear la fecha:', error);
      return dateString;
    }
  }
}

